"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateDynamicCheckboxes = validateDynamicCheckboxes;
exports.getConsentCheckboxValues = getConsentCheckboxValues;
var error_helper_const_1 = require("@src/const/error-handling/error-helper.const");
var translation_1 = __importDefault(require("@src/services/translation"));
function validateDynamicCheckboxes($container, ignoredCheckboxes) {
    var allCheckboxes = $container.find('[data-checkbox]');
    var $checkboxes = ignoredCheckboxes ? allCheckboxes.not(ignoredCheckboxes) : allCheckboxes;
    var isValid = true;
    console.log('found checkboxes', $checkboxes);
    $checkboxes.each(function (i, el) {
        var checkbox = el;
        var $checkbox = $checkboxes.eq(i); // Cash instance for this element
        var attr = checkbox.getAttribute('data-checkbox');
        var mode = (attr || 'required').toLowerCase();
        (0, error_helper_const_1._RemoveStatusFromDomObject)($checkbox);
        console.log('checkbox is', mode, 'and is checked', checkbox.checked);
        if (mode !== 'optional' && !checkbox.checked) {
            (0, error_helper_const_1._AddErrorToDomObject)($checkbox, translation_1.default.t('This is required'));
            checkbox.focus();
            isValid = false; // <- update flag
            return false; // <- stop .each loop
        }
    });
    return isValid;
}
function getConsentCheckboxValues($container) {
    // default all are allowed, thats the default as if we use undefined for it!
    var privacy = {
        letter: true,
        email: true,
        textMessage: true,
        phone: true,
        mySportsMessage: true,
    };
    var $consentCheckboxes = $container.find('[data-consent]');
    console.log('found consents', $consentCheckboxes);
    if (!($consentCheckboxes === null || $consentCheckboxes === void 0 ? void 0 : $consentCheckboxes.length)) {
        return undefined;
    }
    $consentCheckboxes.each(function (i, el) {
        var checkbox = el;
        var consentType = checkbox.getAttribute('data-consent');
        if (!Object.keys(privacy).includes(consentType)) {
            console.error('You used a consent checkbox with value', consentType, 'which is not supported. Supported are', Object.keys(privacy));
            return;
        }
        if (checkbox.checked) {
            privacy[consentType] = true;
        }
        else {
            privacy[consentType] = false;
        }
    });
    console.log('final consents: ', privacy);
    return privacy;
}
